import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const anims = [
  'slideInLeft',
  'slideOutRight',
  'slideInRight',
  'slideOutLeft'
].map((v) => 'animated slow ' + v)
const anim = ref(['', ''])

const app = document.getElementById('app')

const change = () => {
  app && (app.style.overflow = 'hidden')
  setTimeout(() => {
    app && (app.style.overflow = 'auto')
  }, 1000)
}

router.afterEach((to, from) => {
  if (to.name === 'login' && from.name === 'signup') {
    change()
    anim.value = anims.slice(0, 2)
  } else if (to.name === 'signup' && from.name === 'login') {
    change()
    anim.value = anims.slice(2, 4)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createVNode(_Transition, {
        "enter-active-class": anim.value[0],
        "leave-active-class": anim.value[1]
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 2
      }, 1032, ["enter-active-class", "leave-active-class"])
    ]),
    _: 1
  }))
}
}

})